module.exports = "/images/pagination-end.5b90825c5252e12d0fa7cf9b6e731fa3.svg";